const OPEN = 'modals//OPEN'
const CLOSE = 'modals//CLOSE'

export {
  OPEN,
  CLOSE
}
